import { Card, CardBody } from 'reactstrap';

const MessageSkeleton = () => (
    <Card>
        <CardBody>
            <div className="dt-field dt-skeleton mb-3" style={{ width: '40%', height: '24px' }} />
            <div className="dt-field dt-skeleton mb-3" style={{ width: '100%', height: '40px' }} />
            <div className="dt-field dt-skeleton mb-2" style={{ width: '100%', height: '48px' }} />
            <div className="dt-field dt-skeleton mb-2" style={{ width: '100%', height: '48px' }} />
            <div className="dt-field dt-skeleton mb-2" style={{ width: '100%', height: '48px' }} />
            <div className="dt-field dt-skeleton" style={{ width: '100%', height: '48px' }} />
        </CardBody>
    </Card>
);

export default MessageSkeleton;
